import { Suspense } from 'react'

import { LoadingOverlay } from '@saas-ui/react'
import { Outlet, createFileRoute } from '@tanstack/react-router'

import { DashboardLayout } from '#features/common/layouts/dashboard-layout'

export const Route = createFileRoute('/_app/$workspace/_dashboard')({
  component: RouteComponent,
  pendingComponent: () => {
    return (
      <DashboardLayout>
        <LoadingOverlay.Root variant="fill" height="100dvh">
          <LoadingOverlay.Spinner />
        </LoadingOverlay.Root>
      </DashboardLayout>
    )
  },
})

function RouteComponent() {
  return (
    <DashboardLayout>
      <Suspense fallback={<DashboardLoader />}>
        <Outlet />
      </Suspense>
    </DashboardLayout>
  )
}

function DashboardLoader() {
  return (
    <LoadingOverlay.Root variant="fill" height="100dvh">
      <LoadingOverlay.Spinner />
    </LoadingOverlay.Root>
  )
}
